import { get } from 'core_main/request';
import { GetCategoriesParameters } from 'core_main/sdk/get_categories/types';
import {
  makeGetCategoriesEndpoint,
  makeGetCategoryEndpoint,
  makeGetRootCategoryEndpoint,
  validateFetchCategoriesParameters,
  validateFetchCategoryByIdParameters,
} from './helpers';
import {
  FetchCategoriesParameters,
  FetchCategoryByIdParameters,
} from './types';

export const fetchCategories = (parameters: FetchCategoriesParameters) => {
  const validationError = validateFetchCategoriesParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeGetCategoriesEndpoint(parameters));
};
export const fetchRootCategory = (parameters: GetCategoriesParameters) => {
  return get(makeGetRootCategoryEndpoint(parameters));
};
export const fetchCategoryById = (parameters: FetchCategoryByIdParameters) => {
  const validationError = validateFetchCategoryByIdParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeGetCategoryEndpoint(parameters));
};
